<template>
    <div class=" w-full h-full flex justify-center items-center  px-5 lg:px-0 text-sm lg:text-base"
        :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">
        <div class="relative w-full lg:w-1/3 h-auto bg-white rounded-lg flex flex-col shadow">

            <!-- Header -->
            <div class="h-1/4 w-full bg-gray-200 rounded-t-lg flex justify-between items-center p-5">
                <div class="text-lg text-gray-700 font-medium ">{{ $t('admin_create.title') }}</div>
            </div>

            <!-- Content -->
            <div class="h-3/4 w-full p-5 flex flex-col justify-center items-center rounded-b-lg space-y-7">
                <form
                    class="w-full  mx-auto h-full py-5 flex flex-col justify-start items-center space-y-10 px-2 lg:px-0">

                    <div class="w-full flex flex-col justify-start items-center space-y-2"
                        :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">
                        <div class="text-base lg:text-lg w-full lg:mb-2">{{ $t('admin_create.subtitle') }}</div>
                    </div>


                    <div class="w-full flex flex-col justify-center items-center space-y-2 lg:space-y-5">
                        <div class="grid grid-cols-1 lg:grid-cols-2 gap-2 lg:gap-5 w-full">

                            <div>
                                <label class="text-sm mb-2 text-gray-800" for="">{{ $t('admin_create.email') }}</label>
                                <input type="text" :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'" v-model="form.email"
                                    :class="inputClass(formErrors.email.error)"
                                    :placeholder="$t('admin_create.email')" />
                                <p v-if="formErrors.email.error" class="text-sm text-red-500 mt-1">
                                    {{ $t('admin_create.errors.' + formErrors.email.message) }}
                                </p>
                            </div>

                            <div>
                                <label class="text-sm mb-2 text-gray-800" for="">{{ $t('admin_create.phone') }}</label>
                                <input type="text" :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'" v-model="form.phone"
                                    :class="inputClass(formErrors.phone.error)"
                                    :placeholder="$t('admin_create.phone')" />
                                <p v-if="formErrors.phone.error" class="text-sm text-red-500 mt-1">
                                    {{ $t('admin_create.errors.' + formErrors.phone.message) }}
                                </p>
                            </div>

                            <div>
                                <label class="text-sm mb-2 text-gray-800" for="">{{ $t('admin_create.password')
                                }}</label>
                                <input type="password" :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'"
                                    v-model="form.password" :class="inputClass(formErrors.password.error)"
                                    :placeholder="$t('admin_create.password')" />
                                <p v-if="formErrors.password.error" class="text-sm text-red-500 mt-1">
                                    {{ $t('admin_create.errors.' + formErrors.password.message) }}
                                </p>
                            </div>
                            <div>
                                <label class="text-sm mb-2 text-gray-800" for="">{{ $t('admin_create.confirm_password')
                                }}</label>
                                <input type="password" :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'"
                                    v-model="form.confirm_password"
                                    :class="inputClass(formErrors.confirm_password.error)"
                                    :placeholder="$t('admin_create.password')" />
                                <p v-if="formErrors.confirm_password.error" class="text-sm text-red-500 mt-1">
                                    {{ $t('admin_create.errors.' + formErrors.confirm_password.message) }}
                                </p>
                            </div>


                        </div>
                        <div
                            class="flex-col flex lg:flex-row space-y-2 lg:space-y-0 space-x-0 lg:space-x-2 justify-end  items-center w-full  ">
                            <div @click="submit"
                                class="px-3 py-2 text-white rounded-lg bg-primary w-full text-center lg:w-fit mt-4 lg:mt-0 hover:cursor-pointer hover:scale-105 transition duration-200">
                                {{ $t('admin_create.submit') }}</div>
                            <div @click="cancel"
                                class="px-3 py-2  rounded-lg bg-gray-300 text-gray-700 w-full text-center lg:w-fit mt-4 lg:mt-0 hover:cursor-pointer hover:scale-105 transition duration-200">
                                {{ $t('admin_create.cancel') }}</div>
                        </div>
                    </div>

                </form>
            </div>
        </div>
    </div>
</template>

<script setup>
import { createAdmin } from '@/api/admin';
import router from '@/router';
import { defineEmits, ref, watch } from 'vue';



const emit = defineEmits([
    "toggleLoadingOff", "toggleLoadingOn"
]);



const form = ref({
    email: '',
    phone: '',
    password: '',
    confirm_password: '',


});

watch(
    () => form.value.phone,
    (newVal) => {
        form.value.phone = newVal.replace(/\D/g, "");
    }
);

const validatePhone = () => {
    const phone = form.value.phone;

    if (!/^(05|06|07)\d{8}$/.test(phone)) {
        formErrors.value.phone.error = true;
        formErrors.value.phone.message = "phone_invalid"
    } else {
        formErrors.value.phone.error = false;
    }
};

watch(() => form.value.phone, validatePhone);




const validateFields = () => {
    let valid = true;


    Object.keys(formErrors.value).forEach(key => {
        formErrors.value[key].error = false;
        formErrors.value[key].message = '';
    });


    if (!form.value.email) {
        formErrors.value.email = { error: true, message: "email_required" };
        valid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.value.email)) {
        formErrors.value.email = { error: true, message: "email_invalid" };
        valid = false;
    }

    // Phone validation
    if (!form.value.phone) {
        formErrors.value.phone = { error: true, message: "phone_required" };
        valid = false;
    } else if (!/^(05|06|07)\d{8}$/.test(form.value.phone)) {
        formErrors.value.phone = { error: true, message: "phone_invalid" };
        valid = false;
    }


    if (!form.value.password) {
        formErrors.value.password = { error: true, message: "password_required" };
    }

    if (form.value.password && form.value.password.length < 8) {
        formErrors.value.password = { error: true, message: "password_short" };
        valid = false;
    }


    if (form.value.password && form.value.confirm_password !== form.value.password) {
        formErrors.value.confirm_password = { error: true, message: "password_mismatch" };
        valid = false;
    }

    return valid;
};





const submit = () => {

    emit('toggleLoadingOn');
    setTimeout(async () => {

        if (!validateFields()) {
            emit('toggleLoadingOff');

            return;
        }



        try {
            let response = await createAdmin(form.value);
            emit('toggleLoadingOff');
            router.push('/admin/list');
        } catch (error) {
            errorOnUpdate(error.response.data.errors);

        }



    }, 1000);
}

const cancel = () => {
    emit("toggleLoadingOff");
    router.push('/admin/list');


}
const inputClass = hasError =>
    (hasError ? 'border border-red-400 ' : 'border border-primary ') +
    ' transition duration-200 outline-none w-full rounded px-3 py-2 text-sm lg:text-base'


const formErrors = ref({
    email: { error: false, message: '' },
    password: { error: false, message: '' },
    phone: { error: false, message: '' },
    confirm_password: { error: false, message: '' }
});



const errorOnUpdate = (errorMessages) => {


    Object.keys(formErrors.value).forEach(key => {
        formErrors.value[key].error = false;
        formErrors.value[key].message = '';
    });


    Object.entries(errorMessages).forEach(([field, code]) => {
        if (formErrors.value[field] !== undefined) {
            formErrors.value[field].error = true;
            formErrors.value[field].message = code;
        }
    });
};


</script>
<style scoped>
@keyframes bounce-wave {

    0%,
    80%,
    100% {
        transform: translateY(0);
    }

    40% {
        transform: translateY(-8px);
    }
}

.animate-bounce-wave {
    animation: bounce-wave 1.2s infinite ease-in-out;
}

.delay-0 {
    animation-delay: 0s;
}

.delay-150 {
    animation-delay: 0.15s;
}

.delay-300 {
    animation-delay: 0.3s;
}

/* Remove arrows for Chrome, Safari, Edge, and Opera */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Remove arrows for Firefox */
input[type="number"] {
    -moz-appearance: textfield;
}
</style>